import { useMessage } from "../../../hooks/useMessage";
import { SPARE_DELETE, DELETE } from "../../../services";

export const useDelete = () => {
  const { openMessage } = useMessage();

  const onDelete = async (spareId: string): Promise<boolean> => {
    try {
      const res = await DELETE(SPARE_DELETE(spareId));
      openMessage("success", res.message);
      return true;
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.error);
      return false;
    }
  };

  return {
    onDelete,
  };
};
